
<template>
  <v-card flat>
    <v-card-text class="pa-2">
      <v-layout row wrap justify-center ma-0 pa-2>
        <v-flex xs11 sm11 md3 lg3 pa-4>
          <v-card
            class="colorCard rounded-lg elevation-0"
            @click="Fn_ShowDataConsent('Wait')"
          >
            <v-card-text class="pa-2 text-center black--text">
              <p style="font-size: 18px; color: #ffb300">
                {{ $t("consentlist.waitConsent") }}
              </p>
              <v-chip color="#FFB300" dark
                >{{ ItemCount.Wait }} {{ $t("consentlist.list") }}</v-chip
              >
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs11 sm11 md3 lg3 pa-4>
          <v-card
            class="colorCardGreen rounded-lg elevation-0"
            @click="Fn_ShowDataConsent('Active')"
          >
            <v-card-text class="pa-2 text-center black--text">
              <p style="font-size: 18px; color: #077893">
                {{ $t("consentlist.approved") }}
              </p>
              <v-chip color="#077893" dark
                >{{ ItemCount.Active }} {{ $t("consentlist.list") }}</v-chip
              >
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs11 sm11 md3 lg3 pa-4>
          <v-card
            class="colorCardGray rounded-lg elevation-0"
            @click="Fn_ShowDataConsent('Expire')"
          >
            <v-card-text class="pa-2 text-center black--text">
              <p style="font-size: 18px; color: #000">
                {{ $t("consentlist.ExpireConsent") }}
              </p>
              <v-chip color="#000" dark
                >{{ ItemCount.Expire }} {{ $t("consentlist.list") }}</v-chip
              >
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs11 sm11 md3 lg3 pa-4>
          <v-card
            class="colorCardRed rounded-lg elevation-0"
            @click="Fn_ShowDataConsent('Petition')"
          >
            <v-card-text class="pa-2 text-center black--text">
              <p style="font-size: 18px; color: #0040ff">
                {{ $t("consentlist.PetitionConsent") }}
              </p>
              <v-chip color="#4271ff" dark
                >{{ ItemCount.Petition }} {{ $t("consentlist.list") }}</v-chip
              >
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card class="elevation-0" v-if="ShowConsentWait">
        <v-card-text style="max-height: 800px; overflow: auto">
          <v-timeline align-top dense v-for="(item, i) in ConsentWait" :key="i">
            <v-timeline-item color="#FFB300" small>
              <v-card class="elevation-5">
                <v-card-text>
                  <v-layout row wrap justify-center align-center mt-n4>
                    <v-flex xs11 sm11 md12 lg12 mb-5>
                      <strong>{{ item.HeaderConsent }}</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameTh }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameEng }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-if="$t('default') === 'th'">
                      ผู้ขอ: {{ item.ReqNameTh }}
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-else>
                      Requester: {{ item.ReqNameEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      วันที่ส่ง: {{ item.SendAt }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      Sent date: {{ item.SendAtEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md1 lg1>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            v-bind="attrs"
                            v-on="on"
                            dark
                            color="#077893"
                            fab
                            @click="Fn_ViewDetailWait(item)"
                          >
                            <v-icon>mdi-text-box-search-outline</v-icon></v-btn
                          > </template
                        ><span>{{ $t("consentlist.detail") }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs11 sm11 md11 lg12 text-left>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            color="#077893"
                            style="cursor: pointer"
                            small
                            @click="Fn_CopyDetail(item.EmailId)"
                            v-on="on"
                            >mdi-file-multiple-outline</v-icon
                          >
                        </template>
                        <span>{{ $t("consentlist.copy") }}</span>
                      </v-tooltip>
                      {{ $t("consentlist.did") }} {{ item.EmailId }}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
      <v-card class="elevation-0" v-if="ShowConsentActive">
        <v-card-text style="max-height: 800px; overflow: auto">
          <v-timeline
            align-top
            dense
            v-for="(item, i) in ConsentActive"
            :key="i"
          >
            <v-timeline-item color="#077893" small>
              <v-card class="elevation-5">
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 sm11 md12 lg12 mb-5>
                      <strong>{{ item.HeaderConsent }}</strong>
                      &nbsp;
                      <v-chip v-if="item.Step === '1'" color="teal" small dark>
                        {{ $t("consentlist.status1") }}
                      </v-chip>
                      <v-chip v-if="item.Step === '2'" color="info" small dark>
                        {{ $t("consentlist.status2") }}
                      </v-chip>
                      <v-chip
                        v-if="item.Step === '3'"
                        color="indigo"
                        small
                        dark
                      >
                        {{ $t("consentlist.status3") }}
                      </v-chip>
                      <v-chip
                        v-if="item.Step === '4'"
                        color="purple"
                        small
                        dark
                      >
                        {{ $t("consentlist.status4") }}
                      </v-chip>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameTh }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameEng }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-if="$t('default') === 'th'">
                      ผู้ขอ: {{ item.ReqNameTh }}
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-else>
                      Requester: {{ item.ReqNameEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      วันที่ให้ความยินยอม: {{ item.ApproveAt }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      Approve date: {{ item.ApproveAtEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md1 lg1>
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>

                        <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                          <v-list-item
                            @click="fn_checkActionType(list.service, item)"
                            link
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon :color="list.color"
                                >{{ list.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              v-if="$t('default') === 'th'"
                              :inner-text.prop="list.text"
                              style="font-size: 14px"
                            ></v-list-item-title>
                            <v-list-item-title
                              v-else
                              :inner-text.prop="list.text2"
                              style="font-size: 14px"
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
      <v-card class="elevation-0" v-if="ShowConsentExpire">
        <v-card-text style="max-height: 800px; overflow: auto">
          <v-timeline
            align-top
            dense
            v-for="(item, i) in ConsentExpire"
            :key="i"
          >
            <v-timeline-item color="#000" small>
              <v-card class="elevation-5">
                <v-card-text>
                  <v-layout row wrap justify-center align-center mt-n4>
                    <v-flex xs11 sm11 md12 lg12 mb-5>
                      <strong>{{ item.HeaderConsent }}</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameTh }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameEng }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-if="$t('default') === 'th'">
                      ผู้ขอ: {{ item.ReqNameTh }}
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-else>
                      Requester: {{ item.ReqNameEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      วันที่ให้ความยินยอม: {{ item.ApproveAt }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      Approve date: {{ item.ApproveAtEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md1 lg1>
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>

                        <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                          <v-list-item
                            @click="fn_checkActionType(list.service, item)"
                            link
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon :color="list.color"
                                >{{ list.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              v-if="$t('default') === 'th'"
                              :inner-text.prop="list.text"
                              style="font-size: 14px"
                            ></v-list-item-title>
                            <v-list-item-title
                              v-else
                              :inner-text.prop="list.text2"
                              style="font-size: 14px"
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
      <v-card class="elevation-0" v-if="ShowConsentPetition">
        <v-card-text style="max-height: 800px; overflow: auto">
          <v-timeline
            align-top
            dense
            v-for="(item, i) in ConsentPetition"
            :key="i"
          >
            <v-timeline-item color="#4271ff" small>
              <v-card class="elevation-5">
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 sm11 md12 lg12 mb-5>
                      <strong>{{ item.HeaderConsent }}</strong>
                      &nbsp;
                      <v-chip v-if="item.Step === '1'" color="teal" small dark>
                        {{ $t("consentlist.status1") }}
                      </v-chip>
                      <v-chip v-if="item.Step === '2'" color="info" small dark>
                        {{ $t("consentlist.status2") }}
                      </v-chip>
                      <v-chip
                        v-if="item.Step === '3'"
                        color="indigo"
                        small
                        dark
                      >
                        {{ $t("consentlist.status3") }}
                      </v-chip>
                      <v-chip
                        v-if="item.Step === '4'"
                        color="purple"
                        small
                        dark
                      >
                        {{ $t("consentlist.status4") }}
                      </v-chip>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameTh }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      {{ $t("consentlist.organization") }}:
                      {{ item.BusinessNameEng }}
                      <div>({{ item.SourceSystem }})</div>
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-if="$t('default') === 'th'">
                      ผู้ขอ: {{ item.ReqNameTh }}
                    </v-flex>
                    <v-flex xs11 sm11 md3 lg3 v-else>
                      Requester: {{ item.ReqNameEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-if="$t('default') === 'th'">
                      วันที่ขอคำร้อง: {{ item.ApproveAt }}
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 v-else>
                      Approve date: {{ item.ApproveAtEng }}
                    </v-flex>
                    <v-flex xs11 sm11 md1 lg1>
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>

                        <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                          <v-list-item
                            @click="fn_checkActionType(list.service, item)"
                            link
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon :color="list.color"
                                >{{ list.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              v-if="$t('default') === 'th'"
                              :inner-text.prop="list.text"
                              style="font-size: 14px"
                            ></v-list-item-title>
                            <v-list-item-title
                              v-else
                              :inner-text.prop="list.text2"
                              style="font-size: 14px"
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-card-text>
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
    <DialogPetitionRequest
      :show="DialogPetitionRequest"
      :_detail="detail"
      :_Tag="Tag"
      :GetTypeRequest="GetTypeRequest"
      @closeDialog="DialogPetitionRequest = false"
    />
    <DialogDetailPetition
      :show="DialogDetailPetition"
      @closeDialog="DialogDetailPetition = false"
    />
    <DialogGroupDetailEmail
      :item="ItemEmail"
      :show="DialogGroupDetailEmail"
      @closeDialog="DialogGroupDetailEmail = false"
      @reData="Fn_GetDataConsent"
    />
    <DialogGroupDetailOnePlatform
      :item="ItemEmail"
      :show="DialogGroupDetailOnePlatform"
      @closeDialog="DialogGroupDetailOnePlatform = false"
      @reData="Fn_GetDataConsent"
    />
  </v-card>
</template>
<script>
import DialogGroupDetailEmail from "@/components/dialog/ConsentEmail/DialogDetailGroupEmail.vue";
import DialogGroupDetailOnePlatform from "@/components/dialog/ConsentEmail/DialogDetailGroupOnePlatform.vue";
import DialogDetailPetition from "@/components/dialog/ConsentEmail/DialogDetailListEmail.vue";
import DialogPetitionRequest from "@/components/dialog/ConsentEmail/DialogPetitionRequest.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    OverlaySearch,
    DialogPetitionRequest,
    DialogDetailPetition,
    DialogGroupDetailEmail,
    DialogGroupDetailOnePlatform,
  },
  data: (vm) => ({
    dark: false,
    ItemConsent: [],
    ItemCount: [],
    ItemEmail: [],
    ConsentActive: [],
    ConsentExpire: [],
    ConsentWait: [],
    loadingDownloadData: false,
    ShowConsentWait: false,
    ShowConsentActive: false,
    ShowConsentExpire: false,
    ConsentPetition: [],
    ShowConsentPetition: false,
    itemsAction: [
      {
        icon: "mdi-text-box-search-outline",
        text: "ดูรายละเอียด",
        text2: "Details",
        color: "success",
        service: "View",
      },
      {
        icon: "mdi-send-circle-outline",
        text: "ยื่นคำร้อง",
        text2: "Submit a request",
        color: "info",
        service: "Petition",
      },
    ],
    DialogPetitionRequest: false,
    DialogDetailPetition: false,
    DialogGroupDetailEmail: false,
    DialogGroupDetailOnePlatform: false,
    ViewBtn: false,
    detail: "",
    Tag: [],
    GetTypeRequest: [],
    ItemOnePlatform: [],
  }),
  computed: {
    ...mapGetters(["DataGeneralConsent"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    headers() {
      return [
        {
          text: this.$i18n.t("consentlist.Cnumber"),
          value: "SendId",
          sortable: false,
          align: "left",
          width: "17%",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          align: "center",
          value: "SourceSystem",
          sortable: false,
          width: "3%",
        },
        {
          text: this.$i18n.t("consentlist.subject"),
          value: "ConsentHeader",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("consentlist.data"),
          value: "Tag",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("consentlist.date"),
          value: "SendAt",
          align: "center",
          sortable: false,
          width: "14%",
        },
        {
          text: this.$i18n.t("consentlist.expiration"),
          value: "ExpireIn",
          align: "center",
          sortable: false,
          width: "14%",
        },
        {
          text: this.$i18n.t("petition.text14"),
          value: "Status",
          align: "center",
          sortable: false,
          width: "7%",
        },
        {
          text: this.$i18n.t("consentlist.choice"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },

    _SendId: {
      get() {
        return this.DataGeneralConsent.SendId || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataConsent();
  },
  methods: {
    async Fn_GetDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        Email: this.$cookies.get("EmailCMP"),
        BusinessId: this.$cookies.get("BusinessIdEmail"),
        AccessToken: this.$cookies.get("EmailAccessToken"),
        Type: "Group",
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetEmailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemCount = response.data.Message.Count;
            this.ConsentActive = response.data.Message.ConsentActive;
            this.ConsentExpire = response.data.Message.ConsentExpire;
            this.ConsentWait = response.data.Message.ConsentWait;
            this.ConsentPetition = response.data.Message.ConsentPetition;

            if (this.ConsentWait.length > 0) {
              this.ShowConsentWait = true;
            } else if (this.ConsentActive.length > 0) {
              this.ShowConsentActive = true;
            } else if (this.ConsentExpire.length > 0) {
              this.ShowConsentExpire = true;
            } else if (this.ConsentPetition.length > 0) {
              this.ShowConsentPetition = true;
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    fn_checkActionType(val, item) {
      if (val == "View") {
        this.Fn_ViewDetail(item);
      } else if (val == "Petition") {
        this.Fn_GetTypeRequest();
        this.Fn_CheckCancel(item);
      }
    },
    Fn_ViewDetailWait(item) {
      this.ViewBtn = true;
      if (item.SourceSystem === "ONECHAT" && item.Type === "Group") {
        this.ViewBtn = false;
        this.DialogGroupDetailOnePlatform = true;
        this.ItemEmail = item;
      } else if (item.SourceSystem === "EMAIL" && item.Type === "Group") {
        this.ViewBtn = false;
        this.DialogGroupDetailEmail = true;
        this.ItemEmail = item;
      } else {
        this.$cookies.set("SendId", item.SendId);
        this.$store.dispatch("SET_DATA_GENERAL_CONSENT", item);
        this.DialogDetailPetition = true;
      }
    },
    async Fn_ViewDetail(item) {
      this.$cookies.set("SendId", item.SendId);
      this.$store.dispatch("SET_DATA_GENERAL_CONSENT", item);
      this.DialogDetailPetition = true;
    },
    async Fn_Dialog(item) {
      this.Fn_GetTypeRequest();
      this.detail = item;
      this.DialogPetitionRequest = true;
      // this.Fn_CheckCancel();
    },
    async Fn_GetTypeRequest() {
      var payload = {
        Email: this.$cookies.get("EmailCMP"),
        AccessToken: this.$cookies.get("EmailAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "email/GetAllTypeRequest",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.GetTypeRequest = response.data.Message;
            // window.location.reload();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_CheckCancel(val) {
      this.loadingDownloadData = true;
      var payload = {
        SendId: val.SendId,
        Email: this.$cookies.get("EmailCMP"),
        BusinessId: this.$cookies.get("BusinessIdEmail"),
        AccessToken: this.$cookies.get("EmailAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/CheckCancel",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.Fn_DataCheckCancel = response.data.Message;
            this.Tag = response.data.Message.Tag;
            var check = false;
            for (var item of this.Tag) {
              // index += 1;
              item.checkbox = check;
            }
            this.Fn_Dialog(val);
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ShowDataConsent(val) {
      if (val === "Wait") {
        this.ShowConsentWait = true;
        this.ShowConsentActive = false;
        this.ShowConsentExpire = false;
        this.ShowConsentPetition = false;
      } else if (val === "Active") {
        this.ShowConsentWait = false;
        this.ShowConsentActive = true;
        this.ShowConsentExpire = false;
        this.ShowConsentPetition = false;
      } else if (val === "Expire") {
        this.ShowConsentWait = false;
        this.ShowConsentActive = false;
        this.ShowConsentExpire = true;
        this.ShowConsentPetition = false;
      } else if (val === "Petition") {
        this.ShowConsentWait = false;
        this.ShowConsentActive = false;
        this.ShowConsentExpire = false;
        this.ShowConsentPetition = true;
      }
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
  },
  watch: {
    date(val) {
      this.FromDate = this.formatDate2(this.date);
      // var date = new Date(this.FromDate);
      // date.setDate(date.getDate() + 90);
      // this.TodateMax = date.toISOString().substr(0, 10);
    },
    date2(val) {
      this.ToDate = this.formatDate2(this.date2);
    },
  },
};
</script>

<style scoped>
td {
  border-style: hidden !important;
}

input#input-70 {
  cursor: pointer !important;
}
.colorCard {
  background: linear-gradient(to top left, #ffd54f, #fef4da, #fbf9f3);
}
.colorCardGreen {
  background: linear-gradient(
    to top left,
    #1698b8,
    #bfebf6,
    rgb(237, 246, 248)
  );
}
.colorCardGray {
  background: linear-gradient(to top left, #848383, #dfdede, #fdfafa);
}
.colorCardRed {
  background: linear-gradient(to top left, #4271ff, #d2ddff, #fdfafa);
}
</style>
